import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import {Profile} from './components/profile/profile';
import { MsalGuard } from '@azure/msal-angular';
import {LoadingSpinner} from './components/loading-spinner/loading-spinner';

export const routes: Routes = [
  {
    path: '',
    component: LoadingSpinner,
  },
  {
    path: 'home',
    component: HomeComponent,
    // canActivate: [canActivateGuard]
    canActivate: [MsalGuard]
  },
  {
    path: 'profile',
    component: Profile,
    // canActivate: [canActivateGuard]
    canActivate: [MsalGuard]
  },
  {
    path: '**',
    redirectTo: ''
  },
];
